import initialState from "./initialState";

const mutations = {
  resetModule: (state) => (Object.assign(state, initialState())),
  setFirstTransitionStatus: (state, status) => state.isFirstTransition = status
};

export default mutations



// WEBPACK FOOTER //
// ./src/store/modules/onboarding/mutations.js